export const AUTH_TOKEN = '__DESPERTA_CUSTOMER_TOKEN__'
export const DISABLE_CASHBACK_JOIN_BANNER = '_DISABLE_CASHBACK_JOIN_BANNER_'
export const DISABLE_SINGLE_ACCOUNT_BANNER = '_DISABLE_SINGLE_ACCOUNT_BANNER_'
export * from './uf'
export * from './banks'
